const state = {
    salesHierarchyMasterDropDown: [],
    salesHierarchyMasterArr: [],
    salesHierarchyMasterConfigurationArr: [],
    salesHierarchyMasterUploadArr: [],
    configurationDivisionValue: null,
    geoElemets: [],
    salesHierarchyDtlElemetDisableGeoRole: "",
}
  
export default state;
  